import { render, staticRenderFns } from "./Orderreturn.vue?vue&type=template&id=47f0cde5&scoped=true&"
import script from "./Orderreturn.vue?vue&type=script&lang=js&"
export * from "./Orderreturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0cde5",
  null
  
)

export default component.exports